import styled from "styled-components";

const TopPhotoBannerStyles = styled.div`
  height: "500px";
  width: "100%";

  /* .eyebrow {
    text-align: center;
    font-size: 24px;
    color: white;
    line-height: 30px;
    text-shadow: 0px 0px 50px var(--off-black);
    padding-top: 175px;

    span {
      //hack to apply background color to individual text lines
      box-shadow: 0 0 0 6px var(--off-black);
      background-color: var(--off-black);
      //fix firefox
      box-decoration-break: clone;
      line-height: 30px;
      padding: 0 3px 0 6px;
      border: 1px solid var(--off-black);
    }
  } */

  .article-band {
    content: "";
    height: 18px;
    width: 100%;
    background: var(--ts-green);
    position: absolute;
    top: 0;
  }

  .photo-banner-btn {
    display: inline-block;
    height: 48px;
    border-radius: 100px;
    outline: none;
    font-family: var(--header-font);
    font-size: 18px;
    color: white;
    line-height: 47px;
    cursor: pointer;
    padding: 0 40px;
    border: 1.5px solid white;
    background: none;

    &:hover,
    &:active {
      background: white;
      color: var(--off-black);
      border: none;
    }
  }

  .header {
    font-family: var(--header-font);
    text-align: center;
    font-size: 65px;
    line-height: 73px;
    color: white;
    text-transform: uppercase;
    margin-bottom: 10px;
    padding-top: 190px;
    text-shadow: 0px 0px 50px var(--off-black);
  }

  .sub-header {
    font-size: 24px;
    color: white;
    margin: 0 auto;
    text-align: center;
    margin-bottom: 8px;
    max-width: 800px;
    line-height: 30px;
    text-shadow: 0px 0px 50px var(--off-black);
  }

  @media only screen and (max-width: 1075px) {
    .header {
      font-size: 55px;
      line-height: 58px;
    }

    .sub-header {
      font-size: 22px;
      line-height: 28px;
      max-width: 570px;
      width: calc(100vw - 40px);
    }
  }

  @media only screen and (max-width: 650px) {
    .header {
      font-size: 40px;
      line-height: 48px;
      padding: 0 12px;
      padding-top: 150px;
    }

    .sub-header {
      font-size: 20px;
      line-height: 26px;
      max-width: 430px;
      width: calc(100vw - 40px);
    }
  }
`;

export default TopPhotoBannerStyles;
